import { render } from "./RegisterationModal.vue?vue&type=template&id=e63f0a88"
import script from "./RegisterationModal.vue?vue&type=script&lang=js"
export * from "./RegisterationModal.vue?vue&type=script&lang=js"

import "./RegisterationModal.vue?vue&type=style&index=0&id=e63f0a88&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__